import api from './api';

export const getCompany = () => api.get('/empresa');

export default getCompany;
